export {default} from './TeamsListModel';
export * from './TeamsListModel';



// WEBPACK FOOTER //
// ./src/models/TeamsListModel/index.ts